

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// GETALLCOUNTRIESWITHDETAILS
// GETALLCOUNTRIESWITHDETAILS
const GETALLCOUNTRIESWITHDETAILS= createAsyncThunk(
  "getAllCountriesWithDetails/getAllCountriesWithDetails",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllCountriesWithDetailsSlice = createSlice({
  name: "getAllCountriesWithDetailsSlice",
  initialState: {
    getAllCountriesWithDetails: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllCountriesWithDetails: (state) => {
        state.getAllCountriesWithDetails.loading = false
        state.getAllCountriesWithDetails.error = false
        state.getAllCountriesWithDetails.data = []
        state.getAllCountriesWithDetails.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLCOUNTRIESWITHDETAILS.fulfilled, (state, action) => {
      state.getAllCountriesWithDetails = {
        ...state.getAllCountriesWithDetails,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLCOUNTRIESWITHDETAILS.pending, (state, action) => {
      state.getAllCountriesWithDetails = {
        ...state.getAllCountriesWithDetails,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLCOUNTRIESWITHDETAILS.rejected, (state, action) => {
      state.getAllCountriesWithDetails = {
        ...state.getAllCountriesWithDetails,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllCountriesWithDetailsAction = {
    GETALLCOUNTRIESWITHDETAILS,
};

export { getAllCountriesWithDetailsAction };
export default getAllCountriesWithDetailsSlice.reducer;
export const {setInitialStateOfgetAllCountriesWithDetails} = getAllCountriesWithDetailsSlice.actions